import { FC, memo } from 'react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'
import { Box } from '@chakra-ui/react'


const DoctorOutline = createIcon({
  displayName: 'DoctorOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <path
        d="M10,2h4a2,2,0,0,1,2,2V8a4,4,0,0,1-4,4h0A4,4,0,0,1,8,8V4A2,2,0,0,1,10,2Z"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="14.101"
        y1="11.405"
        x2="14.844"
        y2="14.377"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="9.901"
        y1="11.405"
        x2="9.158"
        y2="14.377"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="8"
        y1="14.15658"
        x2="8"
        y2="18"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <circle
        cx="8"
        cy="19.5"
        r="1.5"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="16"
        y1="14.15658"
        x2="16"
        y2="18"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M14.27753,21A1.99271,1.99271,0,0,1,14,20h0a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2h0a1.99271,1.99271,0,0,1-.27753,1"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <line
        x1="16"
        y1="6"
        x2="8"
        y2="6"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <path
        d="M3,19V17.61581A3,3,0,0,1,5.41185,14.674L8.258,14.105a.905.905,0,0,1,.679.134h0a5.52,5.52,0,0,0,6.126,0h0a.905.905,0,0,1,.679-.134l2.84615.569A3,3,0,0,1,21,17.61581V19"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
    </>
  ),
})

const DoctorTwoTone = createIcon({
  displayName: 'DoctorTwoTone',
  viewBox: '0 0 24 24',
  path: (
    <>
      <rect width="24" height="24" fill="none" />
      <Box as="path"
        d="M3,19V17.61581A3,3,0,0,1,5.41185,14.674L8.258,14.105a.905.905,0,0,1,.679.134h0a5.52,5.52,0,0,0,6.126,0h0a.905.905,0,0,1,.679-.134l2.84615.569A3,3,0,0,1,21,17.61581V19"
        fill="light"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box as="path"
        d="M14.27753,21A1.99271,1.99271,0,0,1,14,20h0a2,2,0,0,1,2-2h0a2,2,0,0,1,2,2h0a1.99271,1.99271,0,0,1-.27753,1"
        fill="light"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box as="circle"
        cx="8"
        cy="19.5"
        r="1.5"
        fill="twoToneFillColor"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box as="path"
        d="M10,2h4a2,2,0,0,1,2,2V8a4,4,0,0,1-4,4h0A4,4,0,0,1,8,8V4A2,2,0,0,1,10,2Z"
        fill="light"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box as="line"
        x1="14.101"
        y1="11.405"
        x2="14.844"
        y2="14.377"
        fill="light"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box as="line"
        x1="9.901"
        y1="11.405"
        x2="9.158"
        y2="14.377"
        fill="light"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />
      <Box as="line"
        x1="8"
        y1="14.15658"
        x2="8"
        y2="18"
        fill="light"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />

      <Box as="line"
        x1="16"
        y1="14.15658"
        x2="16"
        y2="18"
        fill="light"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />

      <Box as="line"
        x1="16"
        y1="6"
        x2="8"
        y2="6"
        fill="light"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
      />

    </>
  ),
})

const Doctor: FC<CustomIconProps> = (props) => {
  if (props.variant === 'twoTone') return <CustomIcon as={DoctorTwoTone} {...props} />

  return <CustomIcon as={DoctorOutline} {...props} />


}

export default memo(Doctor)
